/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * The state of the object, which can be set by the user.
 */
export enum EnumBusinessState {
    /**
     * Active
     */
    Active = 0,
    /**
     * Inactive
     */
    Inactive = 1,
    /**
     * Locked
     */
    Locked = 2,
}
